// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".app__MLEditableCovTermMultipleOptComponent__inputControl{max-width:500px}", "",{"version":3,"sources":["webpack://./../common/modules-react/ml-components-common-react/MLEditableCovTermMultipleOptComponent/MLEditableCovTermMultipleOptComponent.module.scss"],"names":[],"mappings":"AAAA,0DACI,eAAA","sourcesContent":[".inputControl {\n    max-width: 500px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"inputControl": "app__MLEditableCovTermMultipleOptComponent__inputControl"
};
export default ___CSS_LOADER_EXPORT___;
